/**
 * Component to redirect users to the sign up flow
 * */
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

const propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

function SignUpRedirect({ location }) {
  return (
    <Redirect
      to={{
        pathname: '/sign-up',
        state: { from: location.pathname },
      }}
    />
  );
}

SignUpRedirect.propTypes = propTypes;

export default SignUpRedirect;
